'use client';

import { ChevronDown } from "lucide-react";
import { useState, useEffect } from "react";
import Select from "react-select";

const API_KEY = "NjZnS2xjN0VKbFhaMUF1U3lhSTFQUEJqSUtEOU9FblNMZ3RZRFU5Tw==";

export function PartnershipForm() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    contact_number: "",
    org: "",
    designation: "",
    state: "",
    city: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [showAlert, setShowAlert] = useState(false);

  // console.log(object)
  // Fetch states on component mount
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const res = await fetch(
          "https://api.countrystatecity.in/v1/countries/IN/states",
          { headers: { "X-CSCAPI-KEY": API_KEY } }
        );
        const data = await res.json();
        setStates(data);
      } catch (err) {
        console.error("Error fetching states:", err);
      }
    };
    fetchStates();
  }, []);

  // Fetch cities when state changes
  const fetchCities = async (stateCode) => {
    if (!stateCode) {
      setCities([]);
      return;
    }
    try {
      const res = await fetch(
        `https://api.countrystatecity.in/v1/countries/IN/states/${stateCode}/cities`,
        { headers: { "X-CSCAPI-KEY": API_KEY } }
      );
      const data = await res.json();
      setCities(data);
    } catch (err) {
      console.error("Error fetching cities:", err);
      setCities([]);
    }
  };

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setForm((prev) => {
      const updated = { ...prev, [field]: value };
      // Reset city when state changes
      if (field === "state") {
        updated.city = "";
        fetchCities(value);
      }
      return updated;
    });
    // Clear error for this field when user starts typing
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    setForm((prev) => {
      const updated = { ...prev, [name]: value };
      if (name === "state") {
        updated.city = "";
        fetchCities(value);
      }
      return updated;
    });
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};

    // Name validation - more than 3 letters
    if (!form.name || form.name.trim().length <= 3) {
      newErrors.name = "Name must be more than 3 letters";
    }

    // Email validation
    if (!form.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    // Phone validation - must be 10 digits only
    const phoneDigits = form.contact_number.replace(/\D/g, "");
    if (!form.contact_number || phoneDigits.length !== 10) {
      newErrors.contact_number = "Phone number must be 10 digits only";
    }

    // Organisation name validation - mandatory
    if (!form.org || form.org.trim() === "") {
      newErrors.org = "Organization name is mandatory";
    }

    // Designation validation - mandatory
    if (!form.designation || form.designation.trim() === "") {
      newErrors.designation = "Designation is mandatory";
    }

    // State validation - mandatory
    if (!form.state || form.state === "") {
      newErrors.state = "Please select a state";
    }

    // City validation - mandatory
    if (!form.city || form.city === "") {
      newErrors.city = "Please select a city";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form before submission
    if (!validateForm()) {
      return;
    }

    setIsSubmitted(true);

    const payload = {
      email: form.email,
      contact_number: form.contact_number,
      name: form.name,
      company_name: form.org,
      user_position: form.designation,
      state: form.state,
      city: form.city,
    };

    try {
      const res = await fetch("/api/partner-registration", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      const response1 = await fetch("/api/zoho/partner-registration", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const datalist = await response1.json();
      console.log("data list is ", datalist);


      if (!res.ok) {
        alert(data?.error || "Failed to submit form");
        setIsSubmitted(false);
        return;
      }

    setShowAlert(true);
      setForm({
        name: "",
        email: "",
        contact_number: "",
        org: "",
        designation: "",
        state: "",
        city: "",
      });
      setErrors({});
      setIsSubmitted(false);
      // Alert will disappear after 5 seconds
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    } catch (error) {
      console.error("Form submission error:", error);
      alert("An error occurred. Please try again.");
      setIsSubmitted(false);
    }
   
  };
  /* ----------- REACT SELECT STYLES ----------- */
  const customStyles = {
    control: (base) => ({
      ...base,
      padding: "2px",
      borderColor: "#e5e7eb",
      borderRadius: "0.375rem",
      boxShadow: "none",
      minHeight: "48px",
      "&:hover": {
        borderColor: "#d1d5db",
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: "#9ca3af",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#1f2937",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#0074A8" : state.isFocused ? "#f3f4f6" : "white",
      color: state.isSelected ? "white" : "#1f2937",
      padding: "10px 12px",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#0074A8",
      },
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "0.375rem",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
    }),
  };

  return (
    <div className="rounded-3xl bg-white/95 shadow-2xl border border-white/60 backdrop-blur-md p-5 md:p-7 lg:p-8 max-w-lg mx-auto">
       {showAlert && <Alert />}
      
       
      <div className="mb-5 md:mb-6">
        <h2 className="text-lg md:text-xl font-semibold text-slate-900">
          Start Your Journey as Our Partner
        </h2>
        <p className="mt-1 text-xs md:text-sm text-slate-500">
          Fill out the form, and we&apos;ll get in touch shortly.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Full name */}
        <InputField
          type="text"
          placeholder="Your Full Name*"
          value={form.name}
          onChange={handleChange("name")}
          error={errors.name}
          required
        />

        {/* Email + Phone */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <InputField
            type="email"
            placeholder="Email Address*"
            value={form.email}
            onChange={handleChange("email")}
            error={errors.email}
            required
          />
          <InputField
            type="tel"
            placeholder="Phone Number*"
            value={form.contact_number}
            onChange={handleChange("contact_number")}
            error={errors.contact_number}
            required
          />
        </div>

        {/* Org name */}
        <InputField
          type="text"
          placeholder="Organization Name*"
          value={form.org}
          onChange={handleChange("org")}
          error={errors.org}
          required
        />

        {/* Designation */}
        <InputField
          type="text"
          placeholder="Your Designation*"
          value={form.designation}
          onChange={handleChange("designation")}
          error={errors.designation}
          required
        />

        {/* State + City */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <Select
              name="state"
              placeholder="Select State*"
              options={states.map((s) => ({ value: s.iso2, label: s.name }))}
              onChange={(opt) => handleSelectChange("state", opt)}
              styles={customStyles}
              isClearable={false}
              isSearchable={true}
              maxMenuHeight={200}
              value={
                form.state
                  ? states.map((s) => ({ value: s.iso2, label: s.name })).find((s) => s.value === form.state)
                  : null
              }
            />
            {errors.state && <p className="mt-1 text-xs text-red-500">{errors.state}</p>}
          </div>
          <div>
            <Select
              name="city"
              placeholder={form.state ? "Select City*" : "Select State First"}
              options={cities.map((c) => ({ value: c.name, label: c.name }))}
              onChange={(opt) => handleSelectChange("city", opt)}
              styles={customStyles}
              isClearable={false}
              isSearchable={true}
              isDisabled={!form.state}
              maxMenuHeight={200}
              value={
                form.city
                  ? cities.map((c) => ({ value: c.name, label: c.name })).find((c) => c.value === form.city)
                  : null
              }
            />
            {errors.city && <p className="mt-1 text-xs text-red-500">{errors.city}</p>}
          </div>
        </div>

        {/* Submit */}
        <button
          type="submit"
          disabled={isSubmitted}
          className="mt-2 w-full h-12 rounded-full bg-[#0074A8] text-white text-sm md:text-base font-semibold shadow-[0_12px_25px_rgba(0,116,168,0.45)] hover:bg-[#0086c3] disabled:opacity-75 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#0074A8] focus-visible:ring-offset-white transition"
        >
          {isSubmitted ? "Submitting..." : "Submit"}
        </button>

        <p className="pt-1 text-[10px] text-slate-400 text-center">
          By submitting this form, you agree to be contacted by our team regarding partnership
          opportunities.
        </p>
      </form>
     
    </div>
  );
}

/* ---------- Input Field Component ---------- */
function InputField({ type = "text", placeholder, value, onChange, error, required = false }) {
  return (
    <div>
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        className={`w-full h-12 md:h-12.5 rounded-xl border ${error ? "border-red-400 focus:ring-red-500/30 focus:border-red-400" : "border-slate-200 focus:border-[#0074A8] focus:ring-[#0074A8]/30"} bg-white px-4 text-sm md:text-[15px] text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 transition`}
      />
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}


function Alert() {
   
    return (
    <div class="absolute p-4 mb-4 flex justify-between align-middle text-sm text-fg-danger-strong rounded-xl bg-[#00c337]" role="alert">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
                </svg>

            Thank you for submitting the form!  We will contact you soon.
        </div>
)}
